import {IAddWebLinkFormBaseValues, mapUploadResourceMetadata} from '../../../../../admin/resources';
import {ICreateWebLinkPayload} from '../../../../../models/resources';

/**
 * Web-link create sends only the base resource metadata from the form.
 * File-oriented fields (imageMetadata, mediaRights, slideNumber, permissionNeeded, etc.)
 * are omitted so we do not write false/0/[] into properties that should stay unset for web links.
 * SCORM create similarly spreads base metadata without those file-only defaults.
 */
export const mapCreateResourceWebLink = (values: IAddWebLinkFormBaseValues): ICreateWebLinkPayload => {
  const metadata = mapUploadResourceMetadata(values);

  return {
    displayName: values.displayName,
    briefDescription: values.briefDescription,
    url: values.webLink,
    isCurrentYear: true,
    metadata,
  };
};
